import { useContext } from "react";
import { Overlay } from "ol";
import Map from "ol/Map";
import "ol/ol.css";
import _ from "lodash";
import VectorLayer from "ol/layer/Vector";
import TileLayer from "ol/layer/Tile";
import VectorSource from "ol/source/Vector";
import TileImage from "ol/source/TileImage";
import View from "ol/View";
import { fromLonLat, getPointResolution } from "ol/proj";
import { Fill, Stroke, Style } from "ol/style";
import TileGrid from "ol/tilegrid/TileGrid";
import Select from "ol/interaction/Select";
import { click } from "ol/events/condition";
import { defaults } from "ol/control/defaults";
import { defaults as defaultInteractions } from "ol/interaction/defaults";
import MousePosition from "ol/control/MousePosition";
import LayerGroup from "ol/layer/Group.js";
import HELPER from "../../utils/helpers/functions.js";
import ZoomSlider from "ol/control/ZoomSlider";
import {
  convertAddressToLowerCase,
  getPlotsFeaturesData,
} from "../../actions/DataActions.js";
import { CHAIN } from "../../utils/constants/config.js";
import {
  TILE_GIRDE_EXTENT,
  TILE_GRIDE_ORIGIN,
  TILE_GRIDE_RESOLUTION,
  TILE_LAYER_EXTENT,
  TILE_GRIDE_TILE_SIZE,
  VIEW_ROTATION,
  tileURL,
  VIEW_EXTENT,
} from "../../utils/constants/map.js";
import { AppContext } from "../walletsManagment/connectors.js";

export const SetupMapHelper = () => {
  const { eth_zoomView, setEthZoomView } = useContext(AppContext);

  return () => {
    const mousePositionControl = new MousePosition({
      className: "custom-mouse-position",
      target: document.getElementById("mouse-position"),
      undefinedHTML: "&nbsp;",
    });
    const getRotationAngle = (angleDegrees) => {
      return Math.PI / (Math.PI / (angleDegrees * (Math.PI / 180)));
    };
    const mapTileLayer = new LayerGroup({
      title: "Overlay",
      layers: [
        new TileLayer({
          title: "Overlay",
          preload: Infinity,
          extent: TILE_LAYER_EXTENT,
          source: new TileImage({
            attributions: "",
            tileGrid: new TileGrid({
              extent: TILE_GIRDE_EXTENT,
              origin: TILE_GRIDE_ORIGIN,
              resolutions: TILE_GRIDE_RESOLUTION,
              tileSize: TILE_GRIDE_TILE_SIZE,
            }),
            tileUrlFunction: tileURL,
          }),
        }),
      ],
    });

    const map = new Map({
      layers: [mapTileLayer],
      target: "map",
      controls: defaults({
        attribution: false,
        zoom: true,
        rotate: false,
        mousePositionControl,
      }),
      interactions: defaultInteractions({
        pinchRotate: false,
      }),
      view: new View({
        center: eth_zoomView.current.center,
        extent: VIEW_EXTENT,
        rotation: getRotationAngle(VIEW_ROTATION),
        zoom: eth_zoomView.current.zoom,
        maxZoom: eth_zoomView.current.maxZoom,
        projection: eth_zoomView.current.projection,
      }),
    });
    const newMarker = document.getElementById("newmarker");
    //condo position
    const logLat = [16.178507043914063, 21.791291137406905];
    const marker = new Overlay({
      position: logLat,
      positioning: "center-center",
      element: document.getElementById("newmarker"),
      stopEvent: false,
    });
    map.addOverlay(marker);

    //for zooming changed condo
    const minLenPixels = 2;
    const lenM = 3000;

    map.on("moveend", function () {
      const svgPixelPos = map.getPixelFromCoordinate(logLat);
      const svgPixelPos2 = map.getPixelFromCoordinate([
        logLat[0] + lenM,
        logLat[1],
      ]);

      let lenPixels = svgPixelPos2[0] - svgPixelPos[0];
      const view = map.getView();
      const projection = view.getProjection();
      const resolutionAtEquator = view.getResolution();
      const center = view.getCenter();

      const pointResolution = getPointResolution(
        projection,
        resolutionAtEquator,
        center
      );
      const resolutionFactor = resolutionAtEquator / pointResolution;
      lenPixels =
        (lenPixels / projection.getMetersPerUnit()) * resolutionFactor;
      const svgWidth = lenPixels * 2;
      if (lenPixels < minLenPixels) newMarker.style.display = "none";
      else {
        newMarker.style.width = svgWidth * 3 + "px";
        newMarker.style.height = svgWidth + "px";
        newMarker.style.display = "block";
      }
    });

    map.addControl(new ZoomSlider());
    map.getView().on("change", (event) => {
      setEthZoomView({
        center: event.target.getCenter(),
        zoom: event.target.getZoom(),
        maxZoom: event.target.getMaxZoom(),
        projection: event.target.getProjection(),
      });
    });
    return map;
  };
};

export const addMapSelect = (map, handlePlotSelection) => {
  const mapSelect = new Select({
    condition: click,
    style: (item) => {
      if (item.getId() >= 0) {
        return [
          new Style({
            fill: new Fill({
              color: "#ff000033",
            }),
            stroke: new Stroke({
              color: "#ff0000",
              width: 0,
            }),
          }),
        ];
      } else {
        return [
          new Style({
            fill: new Fill({
              color: "#00000099",
            }),
            stroke: new Stroke({
              color: "#302f1f",
              width: 0,
            }),
          }),
        ];
      }
    },
  });

  mapSelect.on("select", async (e) => {
    await handlePlotSelection(e);
  });
  map.addInteraction(mapSelect);

  return mapSelect;
};
export const clearSelectedFeature = (mapSelector) => {
  mapSelector?.getFeatures()?.clear();
};

export const getPlotsLayer = (keys, callBack) => {
  getPlotsFeaturesData(CHAIN.EITH, keys, (plotsGeoData, plotsData) => {
    if (plotsGeoData) {
      callBack(
        new VectorLayer({
          source: new VectorSource({
            features: plotsGeoData,
          }),
          style: (item) => {
            if (item.values_.color) {
              return [
                new Style({
                  fill: new Fill({
                    color: item.values_.color,
                  }),
                  stroke: new Stroke({
                    color: "#302f1f",
                    width: 0,
                  }),
                }),
              ];
            } else {
              return [
                new Style({
                  fill: new Fill({
                    color: "#00000000",
                  }),
                }),
              ];
            }
          },
        }),
        plotsData
      );
    } else {
      callBack(null, plotsData);
    }
  });
};

export const plotMataDataChangeListnerHelper =
  (plotsDataRef, vLandlayer) => (snapshot) => {
    snapshot?.docChanges().forEach((change) => {
      if (change.type === "modified") {
        const modifiedPlot = change.doc.data();

        new Promise(function (resolve) {
          const colorValue = HELPER.getColorByStatus(modifiedPlot);
          const feature = vLandlayer
            .getSource()
            .getFeatureById(modifiedPlot?.plot_id);

          if (feature?.values_?.color) feature.values_.color = colorValue;

          feature?.setStyle(
            new Style({
              fill: new Fill({
                color: colorValue,
              }),
              stroke: new Stroke({
                color: "#5D5D5D",
                width: 0,
              }),
            })
          );

          //TODO
          let indexOfSelected = _.findIndex(
            plotsDataRef.current ?? [],
            (item) => item.plot_id == modifiedPlot.plot_id
          );
          if (indexOfSelected > -1) {
            plotsDataRef.current[indexOfSelected] = modifiedPlot;
          }
          resolve();
        }).then(() => {});
      }
    });
  };

export const filterPlots = (
  vLandlayer,
  account,
  plots,
  plotSize = [],
  plotStatus,
  showMyPlots
) => {
  new Promise(function (resolve) {
    let source = vLandlayer.getSource();
    plots?.forEach((plot) => {
      if (
        (plotSize == "all" || plotSize.includes(plot.size)) &&
        ((showMyPlots && plot.owner_id == convertAddressToLowerCase(account)) ||
          plotStatus == "all" ||
          plot.status == plotStatus)
      ) {
        const colorValue = HELPER.getColorByStatus(plot);

        source.getFeatureById(plot?.plot_id)?.setStyle(
          new Style({
            fill: new Fill({
              color: colorValue,
            }),
            stroke: new Stroke({
              color: "#5D5D5D",
              width: 0,
            }),
          })
        );
      } else {
        source.getFeatureById(plot?.plot_id)?.setStyle(new Style(null));
      }
    });

    resolve(plots);
  }).then((result) => {});
};
